import { Paper, Skeleton, Stack, Typography } from "@mui/material";

/**
 * Displays a skeleton for a clause checklist.
 */
export const ClauseChecklistSkeleton = () => {
    return (
        <Paper variant="outlined" sx={{ height: "100%", minHeight: 240 }}>
            <Stack p={2} gap={2}>
                <Stack>
                    <Typography variant="h6" color="primary" fontWeight={500}>
                        <Skeleton sx={{ bgcolor: "primary.main" }} />
                    </Typography>
                    <Typography color="textSecondary" fontWeight={500}>
                        <Skeleton width={120} />
                    </Typography>
                </Stack>
                <Stack gap={2}>
                    <Typography
                        variant="body2"
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: "3",
                            WebkitBoxOrient: "vertical",
                        }}
                    >
                        <Skeleton />
                        <Skeleton />
                        <Skeleton width={"80%"} />
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        fontWeight={500}
                    >
                        <Skeleton width={120} />
                    </Typography>
                </Stack>

                <div>
                    <Skeleton
                        variant="rounded"
                        width={110}
                        height={24}
                        sx={{
                            borderRadius: 4,
                            minHeight: 24,
                            bgcolor: "primary.main",
                        }}
                    />
                </div>
            </Stack>
        </Paper>
    );
};
